export enum EntityEnum {
  AFP_POPULAR = 2004,
  PLANES_COMPLEMENTARIOS_AFP_POPULAR = 3065,
}
